import { axiosJwt } from '@/shared/auth/axiosJwt';

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_CONVENIOSEXECUCAODIRETA_PORT}${process.env.VUE_APP_API_PATH}/conveniosexecucaodireta`;
const urlBase = `${api}`;

export default {
    obterTodasAlteracoesTemplateBasePorConvenio(idCnt) {
        return axiosJwt.get(`${urlBase}/${idCnt}/relatorios/prestacaocontas/obteralteracoestemplatebase`);
    },

    salvarTodasAlteracoesTemplateBasePorConvenio(idCnt, prestacoesContasRelatoriosNovosDtos) {
        return axiosJwt.post(`${urlBase}/${idCnt}/relatorios/prestacaocontas/atualizartemplatebase`, prestacoesContasRelatoriosNovosDtos);
    },

    resetarTodasAlteracoesTemplateBasePorConvenio(idCnt) {
        return axiosJwt.delete(`${urlBase}/${idCnt}/relatorios/prestacaocontas/resetaralteracoestemplatebase`);
    },

    baixarRelatorioPrestacaoContas(idCnt, cpfCnpj) {
        return axiosJwt.get(`${urlBase}/${idCnt}/relatorios/prestacaocontas/${cpfCnpj}/relatorio`, {
            responseType: 'blob',
        });
    },
};
